const groupBasePath = '/languages';

const LanguageConst = {
    basePath : groupBasePath
};

export default LanguageConst;